import { Link } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import './navigation.css'


const ToggleMenuBtn = ({ showHeader, handleClick }) => <div className={`${showHeader ? 'navtoggle-visible' : 'navtoggle-hidden'} site-nav-toggle`}> <MenuIcon onClick={handleClick} id="mobile-nav-hamburger-btn" className={"mobile-nav-toggle mobile-only"} /> </div>

const SiteNavBrand = ({ handleClick }) => {
  return (
    <a href="/" onClick={handleClick} className="site-nav-brand">
      <img className="logo-banner" src="/img/brand/crochetedly_logo.jpg" />
    </a>
  )
}

const NavMenuLink = ({ path, label, navLayout, handleClick }) => <Link className={"site-nav-link " + navLayout} onClick={handleClick} to={path}>{label}</Link>

const NavigationMenu = ({ handleNavInput, navLayout }) => {

  const menu_items = [
    { path: '/', label: 'Home' },
    { path: '/voices_for_palestine', label: 'Voices For Palestine' },
    { path: '/events', label: 'Events' },
    { path: '/letters_of_lamentation', label: 'Letters of Lamentation' },
    { path: '/presentations', label: 'Presentations' },
    { path: '/printables', label: 'Printables' },
    { path: '/contact_info', label: 'Contact Info' }
  ]

  return (
    <nav className={"site-nav " + navLayout}>
      <div className="site-nav-links">
        {menu_items.map(pg => (<NavMenuLink path={pg.path} label={pg.label} navLayout={navLayout} handleClick={handleNavInput} />))}
      </div>
    </nav>
  )
}

export { ToggleMenuBtn, SiteNavBrand };

export default NavigationMenu;